import DOMPurify from "dompurify";
import { marked } from "marked";
import { isExternalUrl } from "./url";

// Note: サーバーサイドでは動作しません。(DOMPurifyのせい)
export const renderMarkdown = (markdown: string) => {
  // 外部リンクを新しいタブで開くようにする
  marked.use({
    renderer: {
      link(href, title, text) {
        const targetAttribute =
          href && isExternalUrl(href) ? 'target="_blank"' : "";
        const html = `<a href="${href ?? "#"}" title="${
          title ?? ""
        }" ${targetAttribute}>${text ?? ""}</a>`;
        return html;
      },
    },
    gfm: true,
    breaks: true,
  });
  const dirtyHtml = marked.parse(markdown);

  // デフォルト設定だとDOMPurifyがaタグのtarget属性を消し去るので許可してあげる
  const purificationConfig = {
    ADD_ATTR: ["target"],
  };
  return DOMPurify.sanitize(dirtyHtml, purificationConfig);
};
